import { Row, Col } from "antd";
import { Proposal3 } from "./prop3body";
import { Prop3side } from "./prop3side";
function PropLayout3() {
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col md={6}>
          <div className="logo" style={{ marginBottom: "45px" }}>
            <img className="imgh" src="../../images/logo.png" alt="Logo" />
          </div>
          <Prop3side />
        </Col>
        <Col md={18}>
          <Proposal3 />
        </Col>
      </Row>
    </div>
  );
}

export { PropLayout3 };
